import './less/app.less';
import './less/custom.less';
import './less/teams.less';

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import Moment from 'moment';
import { ConfigProvider } from 'antd/lib';
import frFR from 'antd/es/locale/fr_FR';
import { RelayEnvironmentProvider } from 'react-relay';
import { getEnvironment } from './_graphql/Environment';
import Routes from './Routes';
import ImagesPreloader from './ImagesPreloader/ImagesPreloader';
import { imageUrls } from './ImagesPreloader/imagesList';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/fr'; 

const getDocumentRoot = () => {
  const element = document.createElement('div');
  document.body.appendChild(element);
  return element;
};

Moment.locale('fr');

const App = ({ environment }) => {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  return (
    <>
      {!imagesLoaded && <ImagesPreloader urls={imageUrls} onLoaded={() => setImagesLoaded(true)} />}
      {imagesLoaded && (
        <RelayEnvironmentProvider environment={environment}>
          <ConfigProvider locale={frFR}>
            <CookiesProvider>
              <Routes />
            </CookiesProvider>
          </ConfigProvider>
        </RelayEnvironmentProvider>
      )}
    </>
  );
};

(async () => {
  const environment = await getEnvironment();
  ReactDOM.render(<App environment={environment} />, getDocumentRoot());
})();
